var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardFold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 104,
    viewBox: "0 0 92 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.15962e-05 27.2563L85.254 27.2563L88.1604 27.2563L76.1774 30.923L39.0424 47.423L-7.62939e-06 72.6314L-1.15962e-05 27.2563Z",
    fill: "#0F0F0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.823 57.9567C72.2802 45.2288 78.9277 28.9028 87.3779 28.2833C87.8636 28.2488 88.3324 28.0168 88.8366 28.0264C88.7247 28.0187 88.6082 27.9978 88.5007 27.9944C79.739 27.7286 66.2072 32.7895 52.1101 39.8276L68.823 57.9567Z",
    fill: "url(#paint0_linear_17_411)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1115 39.8283C31.7559 49.9945 10.2112 64.2896 0.136829 72.6583C18.6653 59.2609 41.1504 52.9095 68.8247 57.9664L52.1119 39.8373L52.1115 39.8283Z",
    fill: "#E7E8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5014 27.9946C67.0912 27.3424 17.1903 58.5037 0.131926 72.6535C18.6604 59.2561 40.5991 52.3112 68.2734 57.3681C71.9146 43.9453 79.1579 27.8314 88.8291 28.0269C88.7172 28.0193 88.6007 27.9984 88.4932 27.995L88.5014 27.9946Z",
    fill: "url(#paint1_linear_17_411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_411",
    x1: 69.9253,
    y1: 31.9666,
    x2: 77.6888,
    y2: 54.9604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_411",
    x1: 41.9604,
    y1: 41.4081,
    x2: 49.4892,
    y2: 63.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F5C447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F6CA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F8DE77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9EF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FAE7A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFold);
export default __webpack_public_path__ + "static/media/card-fold.67696905ff33bf893d07890689bfab52.svg";
export { ForwardRef as ReactComponent };